import { EXPERIMENT_HANDRAISER_SRP, EXPERIMENT_HANDRAISER_STC } from 'constants/experiments';
import { ChatHandRaiserConfigType } from './types';
import { MILLISECONDS_PER_DAY, MILLISECONDS_PER_SECOND } from 'constants/date';
import {
  HANDRAISER_NAME_PURCHASE,
  HANDRAISER_NAME_SRP,
  HANDRAISER_NAME_STC,
} from 'constants/handraiser';

export const config: ChatHandRaiserConfigType = {
  defaultDisplayDelay: 10 * MILLISECONDS_PER_SECOND,
  defaultElapsedExpiry: MILLISECONDS_PER_DAY,
  handraisers: {
    '/purchase/steps/drivers-license': {
      enabled: true,
      regexMatch: false,
      displayDelayMobile: 45 * MILLISECONDS_PER_SECOND,
      displayDelayWeb: 45 * MILLISECONDS_PER_SECOND,
      displayMessage: `having an issue uploading your driver's license?`,
      messageIntent: "I'm having an issue uploading the driver's license.",
      handraiserName: HANDRAISER_NAME_PURCHASE,
    },
    '/purchase/steps/down-payment': {
      enabled: true,
      regexMatch: false,
      displayDelayMobile: undefined,
      displayDelayWeb: undefined,
      displayMessage: `questions about when your payment is processed?`,
      messageIntent: 'When is my payment processed?',
      handraiserName: HANDRAISER_NAME_PURCHASE,
    },
    '/sell-my-car': {
      enabled: true,
      regexMatch: false,
      displayDelayMobile: undefined,
      displayDelayWeb: 7 * MILLISECONDS_PER_SECOND,
      displayMessage: `questions about the selling process?`,
      messageIntent: 'How does the selling process work?',
      experiment: EXPERIMENT_HANDRAISER_STC.name,
      experimentBucket: EXPERIMENT_HANDRAISER_STC.buckets['handraiser-landing'],
      handraiserName: HANDRAISER_NAME_STC,
    },
    '/sell-my-car/offer/.*': {
      enabled: true,
      regexMatch: true,
      displayDelayMobile: 15 * MILLISECONDS_PER_SECOND,
      displayDelayWeb: undefined,
      displayMessage: `questions about scheduling your appointment?`,
      messageIntent: 'How do I schedule my appointment?',
      experiment: EXPERIMENT_HANDRAISER_STC.name,
      experimentBucket: EXPERIMENT_HANDRAISER_STC.buckets['handraiser-offer'],
      handraiserName: HANDRAISER_NAME_STC,
    },
    '/cars/filters.*': {
      enabled: true,
      regexMatch: true,
      displayDelayMobile: 30 * MILLISECONDS_PER_SECOND,
      displayDelayWeb: 30 * MILLISECONDS_PER_SECOND,
      elapsedExpiry: null,
      experiment: EXPERIMENT_HANDRAISER_SRP.name,
      experimentBucket: EXPERIMENT_HANDRAISER_SRP.buckets['handraiser'],
      handraiserName: HANDRAISER_NAME_SRP,
    },
  },
};
